import { z } from 'zod';
import { avatarUrlSchema, nameSchema } from '@/utils/schemas';

export const tagScheme = z.object({
  Id: z.number(),
  TagName: nameSchema,
  TagCount: z.number(),
  TagMember: z.object({ Id: z.number(), Name: nameSchema, RemarkName: nameSchema }).array(),
});

export type Tag = z.infer<typeof tagScheme>;

export const tagMemberScheme = z.object({
  TagId: z.number(),
  MemberId: z.number(),
  NickName: nameSchema,
  RemarkName: nameSchema,
  HeadImg: avatarUrlSchema,
});

export type TagMember = z.infer<typeof tagMemberScheme>;

export const createdTagScheme = z.object({
  Id: z.number(),
  Name: nameSchema,
});
export type CreatedTag = z.infer<typeof createdTagScheme>;

export const getTagsWithLimitScheme = z.object({
  Tags: z.array(tagScheme),
  TagMemberLimit: z.number(),
});

export type GetTags = z.infer<typeof getTagsWithLimitScheme>;
